// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeAwardGetForAccountBody = {
  accountId: string;
};

export type typeAwardGetForAccountOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    thisSeason: {
      medalsEarned: number;
      medalsCustom: number;
      trophiesEarned: number;
      trophiesCustom: number;
    };
    allTime: {
      medalsEarned: number;
      medalsCustom: number;
      trophiesEarned: number;
      trophiesCustom: number;
    };
    awards: {
      awardGrantId: string;
      poolId: string;
      contestId: string | null;
      contestName: string | null;
      kind: "medal" | "trophy";
      source: "earned" | "custom";
      name: string;
      color:
        | "color1"
        | "color2"
        | "color3"
        | "color4"
        | "color5"
        | "color6"
        | "color7"
        | "color8";
      isThisSeason: boolean;
      grantedAt: string;
    }[];
  };
};

export type typeAwardGetForAccountOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeAwardGetForAccountOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeAwardGetForAccountOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaAwardGetForAccountBody = {
  type: "object",
  properties: { accountId: { type: "string", maxLength: 3000, minLength: 1 } },
  required: ["accountId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createAwardGetForAccount(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaAwardGetForAccountBody);
  }

  return async function postAwardGetForAccount(
    payload: typeAwardGetForAccountBody,
  ): Promise<
    typeAwardGetForAccountOutput200 | typeAwardGetForAccountOutput400
  > {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postAwardGetForAccount" failed before calling the network. #76bd0e949594`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#76bd0e949594" },
        },
        data: null,
      } as typeAwardGetForAccountOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/award/get-for-account`,
      httpMethod: "POST",
      options,
    })) as typeAwardGetForAccountOutput200 | typeAwardGetForAccountOutput400;
  };
}
